import React from 'react';

import Image_1 from '../../assets/stripe-onboarding_1.png';
import Image_2 from '../../assets/stripe-onboarding_2.png';
import Image_3 from '../../assets/stripe-onboarding_3.png';
import Image_4 from '../../assets/stripe-onboarding_4.png';
import Image_5 from '../../assets/stripe-onboarding_5.png';
import Image_6 from '../../assets/stripe-onboarding_6.png';
import Image_7 from '../../assets/stripe-onboarding_7.png';
import Image_8 from '../../assets/stripe-onboarding_8.png';

import SecImage_1 from '../../assets/security-check_1.png';
import SecImage_2 from '../../assets/security-check_2.png';
import SecImage_3 from '../../assets/security-check_3.png';
import SecImage_4 from '../../assets/security-check_4.png';
import SecImage_5 from '../../assets/security-check_5.png';
import SecImage_6 from '../../assets/security-check_6.png';
import SecImage_7 from '../../assets/security-check_7.png';
import SecImage_8 from '../../assets/security-check_8.png';

import { Loader } from '@/components/Common';
import { paths } from '@/config';
import { Link } from 'react-router-dom';
import { useHowToSalesAccountHooks } from '../../hooks';
import { CopyArea } from './copy-area';
import './style.scss';

const core = () => {
  const {
    data,
    isLoading,
    handleWebSiteCopy,
    website,
    clipboard,
    isError,
  } = useHowToSalesAccountHooks();

  const scrollToSection = (id: string) => () => {
    document
      .getElementById(id)
      ?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <div className="a__introduction_howto_sales_account">
      <div className="w__introduction_howto_sales_account">
        <header>Stripeの登録方法について</header>
        <div className="introduction_howto_sales_account-warning">
          <p>
            正しく項目が登録できていないことや、Stripeの案内に沿った対応がされていないことが原因で、Stripeの審査を通過せず、売上金の入金が保留・停止される事例が発生しています。
            <br />
            必ず、下記の手順と入力項目をご確認の上、登録してください。
            <br />
            また、Stripeの登録画面および審査項目は随時変更されるため、画面上に「必要な対応」「申告書を提出」「本人確認」「追加情報の提出」等が表示されている場合は、Stripe画面上の案内を優先してご対応ください。
            <br />
            未対応の場合、売上金の入金が停止されることがあります。
          </p>
        </div>
        <div className="introduction_howto_sales_account-warning">
          <p>
            審査が通らず追加資料を求められた場合、
            <Link to={paths.introduction.faq}>こちら</Link>
            のページをご確認ください
          </p>
        </div>
        <div className="explain">
          マイページの「売上げ受取口座を登録する」ボタンを押すと、Stripeの登録画面が開きます。
          <br />
          FishSale以外でStripeを活用しない場合には、設問に対して次のとおり回答してください。
          <br />
          FishSale以外でもご利用される場合には、設問に従いご回答ください。
        </div>
        <nav className="introduction_howto_sales_account--toc">
          <p className="introduction_howto_sales_account--toc-title">目次</p>
          <ul>
            <li>
              <button
                type="button"
                onClick={scrollToSection('stripe-onboarding-steps')}
              >
                Stripeの登録手順
              </button>
            </li>
            <li>
              <button
                type="button"
                onClick={scrollToSection('security-check-answers')}
              >
                「セキュリティ対策についてお知らせください」の回答内容
              </button>
            </li>
          </ul>
        </nav>
        <div className="answer_example" id="stripe-onboarding-steps">
          <p className="introduction_howto_sales_account--step">
            STEP1 基本事項の登録
          </p>
          <p>
            「ビジネスの所在地」は「日本」、「事業形態」は「個人または個人事業主」を選択してください（法人としてご利用の場合は該当の事業形態を選択してください）。
          </p>
          <a href={Image_1} target="_blank" rel="noopener noreferrer">
            <img
              src={Image_1}
              width={855}
              height={484}
              loading="lazy"
              decoding="async"
            />
          </a>

          <p className="introduction_howto_sales_account--step">
            STEP2 個人情報の確認
          </p>
          <p>
            ご本人のお名前・メールアドレス・生年月日・自宅住所・電話番号を入力してください。
            <br />
            本人確認に使用されるため、住民票等の公的書類と一致する正確な情報を入力してください。相違があると審査を通過できず、売上金が入金されません。
          </p>
          <a href={Image_2} target="_blank" rel="noopener noreferrer">
            <img
              src={Image_2}
              width={723}
              height={800}
              loading="lazy"
              decoding="async"
            />
          </a>

          <p className="introduction_howto_sales_account--step">
            STEP3 ビジネスの詳細
          </p>
          <p>
            「ウェブサイト」にはあなたのユーザーページを下記よりコピーし入力してください。
          </p>
          {window.isAuthed && !isLoading && data && (
            <div className="introduction_howto_sales_account--copy">
              <label>
                <span className="textbox-label">ウェブサイト</span>
                <input
                  type="text"
                  className="textbox"
                  value={website}
                  onClick={handleWebSiteCopy}
                  readOnly
                />
              </label>
              <p className="description">クリックするとコピーされます。</p>
              {clipboard.copied && <p className="balloon">コピーしました</p>}
            </div>
          )}
          {isLoading && window.isAuthed && (
            <div className="introduction_howto_sales_account--loader">
              <Loader />
            </div>
          )}
          {!window.isAuthed && (
            <p className="introduction_howto_sales_account-warning">
              ユーザーページを取得するために、
              <a href={paths.before.signin}>ログイン</a>してください
            </p>
          )}
          {window.isAuthed && isError && (
            <p className="introduction_howto_sales_account-warning">
              読み込みに失敗しました。ページを再度読み込んでください。
            </p>
          )}
          <p>「商品の説明」には下記をコピーし入力してください。</p>
          <a href={Image_3} target="_blank" rel="noopener noreferrer">
            <img
              src={Image_3}
              width={657}
              height={548}
              loading="lazy"
              decoding="async"
            />
          </a>
          <CopyArea label="商品の説明" mb={49}>
            釣った魚をその場で出品して、ほしい時にほしい人に届ける魚専門セリアプリです
          </CopyArea>

          <p className="introduction_howto_sales_account--step">
            STEP4 割賦販売法に関する質問
          </p>
          <p>
            過去5年間に特定商取引法への違反や、消費者契約法違反による敗訴判決に該当がない場合は「いいえ」を選択してください。
          </p>
          <a href={Image_4} target="_blank" rel="noopener noreferrer">
            <img
              src={Image_4}
              width={690}
              height={375}
              loading="lazy"
              decoding="async"
            />
          </a>

          <p className="introduction_howto_sales_account--step">
            STEP5 入金のための口座を追加
          </p>
          <p>
            売上金を受け取る銀行口座を登録してください。
            <br />
            「口座名義」はカタカナで、Stripeに登録した氏名と一致するご本人名義の口座を入力してください。名義が一致しない場合、入金されません。
            <br />
            「入金スケジュール」はどちらを選択しても構いません（あとからStripeの管理画面で変更できます）。
          </p>
          <a href={Image_5} target="_blank" rel="noopener noreferrer">
            <img
              src={Image_5}
              width={578}
              height={855}
              loading="lazy"
              decoding="async"
            />
          </a>

          <p className="introduction_howto_sales_account--step">
            STEP6 顧客向けの表示情報
          </p>
          <p>
            「明細書表記」と「カスタマーサポート」には下記をコピーし入力してください。
          </p>
          <a href={Image_6} target="_blank" rel="noopener noreferrer">
            <img
              src={Image_6}
              width={589}
              height={936}
              loading="lazy"
              decoding="async"
            />
          </a>
          <CopyArea label="店舗名・サービス名">FishSale</CopyArea>
          <CopyArea>フィッシュセール</CopyArea>
          <CopyArea mb={16}>FISHSALE.JP</CopyArea>

          <CopyArea label="店舗名・サービス名（短縮版）">FishSale</CopyArea>
          <CopyArea>フィッシュセール</CopyArea>
          <CopyArea mb={16}>FISHSALE</CopyArea>

          <CopyArea mb={40} label="顧客サポート電話番号">
            05053576320
          </CopyArea>

          <p className="introduction_howto_sales_account--step">
            STEP7 Climate の寄付（オプション）
          </p>
          <p>
            気候変動対策への寄付は任意です。寄付をしない場合は「今はスキップ」を選択してください。
          </p>
          <a href={Image_7} target="_blank" rel="noopener noreferrer">
            <img
              src={Image_7}
              width={595}
              height={528}
              loading="lazy"
              decoding="async"
            />
          </a>

          <p className="introduction_howto_sales_account--step">
            STEP8 税額計算（オプション）
          </p>
          <p>
            Stripe Tax
            の利用は任意です。利用しない場合は「今はやめておく」を選択してください。
            <br />
            以上で登録は完了です。入力内容の確認画面が表示された場合は、内容を確認して送信してください。
          </p>
          <a href={Image_8} target="_blank" rel="noopener noreferrer">
            <img
              src={Image_8}
              width={645}
              height={565}
              loading="lazy"
              decoding="async"
            />
          </a>
        </div>
        <div className="answer_example">
          <p
            className="introduction_howto_sales_account--section"
            id="security-check-answers"
          >
            セキュリティ対策についてお知らせください
          </p>
          <div className="introduction_howto_sales_account-warning">
            <p>
              FishSale以外でもStripeをご利用の場合など、登録時に「セキュリティ対策についてお知らせください」という申告書の入力を求められることがあります。
              <br />
              表示された場合は、下記の回答例を参考にご入力ください。
            </p>
          </div>

          <p className="introduction_howto_sales_account--step">
            導入方法の予定について
          </p>
          <ul className="introduction_howto_sales_account--answer-list">
            <li>
              どのように決済を行いますか？：
              <strong>
                その他 (例えば、Stripe Checkout や Payment Element)
              </strong>
            </li>
            <li>
              商品やサービスをオンラインで販売していますか？：
              <strong>はい</strong>
            </li>
          </ul>
          <a href={SecImage_1} target="_blank" rel="noopener noreferrer">
            <img
              src={SecImage_1}
              width={854}
              height={629}
              loading="lazy"
              decoding="async"
            />
          </a>

          <p className="introduction_howto_sales_account--step">
            1. 管理者画面のアクセス制限と管理者の ID / PW 管理
          </p>
          <ul className="introduction_howto_sales_account--answer-list">
            <li>
              管理者のアクセス可能なIPアドレスを制限する。IPアドレスを制限できない場合は管理画面にベーシック認証等のアクセス制限を設ける。：
              <strong>はい</strong>
            </li>
            <li>
              取得されたアカウントを不正使用されないよう二段階認証または二要素認証を採用する。：
              <strong>いいえ</strong>
            </li>
            <li>
              管理者画面のログインフォームでは、アカウントロック機能を有効にし、10回以下のログイン失敗でアカウントをロックする。：
              <strong>いいえ</strong>
            </li>
          </ul>
          <a href={SecImage_2} target="_blank" rel="noopener noreferrer">
            <img
              src={SecImage_2}
              width={787}
              height={487}
              loading="lazy"
              decoding="async"
            />
          </a>

          <p className="introduction_howto_sales_account--step">
            2. データディレクトリ露出による設定不備対策
          </p>
          <ul className="introduction_howto_sales_account--answer-list">
            <li>
              公開ディレクトリには、重要なファイルを配置しない。：
              <strong>はい</strong>
            </li>
            <li>
              Webサーバーや
              Webアプリケーションによりアップロード可能な拡張子やファイルを制限する等の設定を行う。：
              <strong>はい</strong>
            </li>
          </ul>
          <a href={SecImage_3} target="_blank" rel="noopener noreferrer">
            <img
              src={SecImage_3}
              width={775}
              height={327}
              loading="lazy"
              decoding="async"
            />
          </a>

          <p className="introduction_howto_sales_account--step">
            3. Web アプリケーションの脆弱性対策
          </p>
          <ul className="introduction_howto_sales_account--answer-list">
            <li>
              脆弱性診断またはペネトレーションテストを定期的に実施し、必要な修正対応を行う。：
              <strong>いいえ</strong>
            </li>
            <li>
              SQLインジェクションの脆弱性やクロスサイト・スクリプティングの脆弱性対策を行う。：
              <strong>はい</strong>
            </li>
            <li>
              Webアプリケーションを開発またはカスタマイズされている場合には、セキュアコーディング済みであるか、ソースコードレビューを行い確認する。その際は、入力フォームの入力値チェックも行う。：
              <strong>はい</strong>
            </li>
          </ul>
          <a href={SecImage_4} target="_blank" rel="noopener noreferrer">
            <img
              src={SecImage_4}
              width={794}
              height={479}
              loading="lazy"
              decoding="async"
            />
          </a>

          <p className="introduction_howto_sales_account--step">
            4. マルウェア対策としてのウイルス対策ソフトの導入、運用
          </p>
          <ul className="introduction_howto_sales_account--answer-list">
            <li>
              マルウェア検知/除去などの対策としてウイルス対策ソフトを導入して、シグネチャーの更新や定期的なフルスキャンなどを行う。：
              <strong>いいえ</strong>
            </li>
          </ul>
          <a href={SecImage_5} target="_blank" rel="noopener noreferrer">
            <img
              src={SecImage_5}
              width={791}
              height={206}
              loading="lazy"
              decoding="async"
            />
          </a>

          <p className="introduction_howto_sales_account--step">
            5. 悪質な有効性確認、クレジットマスターへの対策
          </p>
          <ul className="introduction_howto_sales_account--answer-list">
            <li>
              悪質な有効性確認、クレジットマスターに対して、セキュリティ・チェックリストに記載の対策を1つ以上実施している。：
              <strong>はい</strong>
            </li>
          </ul>
          <a href={SecImage_6} target="_blank" rel="noopener noreferrer">
            <img
              src={SecImage_6}
              width={777}
              height={351}
              loading="lazy"
              decoding="async"
            />
          </a>

          <p className="introduction_howto_sales_account--step">
            6. 不正ログイン対策
          </p>
          <ul className="introduction_howto_sales_account--answer-list">
            <li>
              ユーザー登録、ログイン、アカウント変更の対策：
              <strong>不審なIPアドレスからのアクセス制限</strong>
            </li>
          </ul>
          <a href={SecImage_7} target="_blank" rel="noopener noreferrer">
            <img
              src={SecImage_7}
              width={902}
              height={447}
              loading="lazy"
              decoding="async"
            />
          </a>

          <p className="introduction_howto_sales_account--step">委託先情報</p>
          <ul className="introduction_howto_sales_account--answer-list">
            <li>
              貴社に代わってどなたがセキュリティ対策を実行しますか？：
              <strong>委託先企業</strong>
            </li>
            <li>
              委託先企業名：<strong>Fresh Speed株式会社</strong>
            </li>
            <li>
              ASPカート事業者名：<strong>FishSale</strong>
            </li>
            <li>
              PCI DSS 準拠の審査を行った QSA（Qualified Security Assessor）：
              <strong>なし</strong>
            </li>
          </ul>
          <a href={SecImage_8} target="_blank" rel="noopener noreferrer">
            <img
              src={SecImage_8}
              width={909}
              height={700}
              loading="lazy"
              decoding="async"
            />
          </a>
        </div>
      </div>
    </div>
  );
};

export default core;
